/** Notifications sahifasi lug'ati (uz). */
export default {
  title: "Bildirishnomalar",
  total_one: "jami {{count}} ta",
  total_other: "jami {{count}} ta",
  markAll: "Hammasini o'qilgan deb belgilash",
  marked_one: "{{count}} tasi o'qilgan deb belgilandi",
  marked_other: "{{count}} tasi o'qilgan deb belgilandi",
  nothingToMark: "Belgilash uchun hech narsa yo'q",
  markFailed: "O'qilgan deb belgilab bo'lmadi",
  unread: "O'qilmagan",
  loadFailed: "Bildirishnomalarni yuklab bo'lmadi.",
  caughtUp: "Hammasi o'qilgan",
  none: "Hali bildirishnomalar yo'q",
  desc: "Tasdiqlashlar, o'tkazishlar va eslatmalar shu yerda ko'rinadi.",
  pagination: "bildirishnoma",
};
